import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import TextfieldStyles from './textfieldStyles';

const Textfield = forwardRef((props, ref) => {
  if (props.type === 'number') {
    return (
      <TextfieldStyles ref={ref} id={props.name} as="input" type={props.type} {...props}>
        {props.children}
      </TextfieldStyles>
    );
  }
  return (
    <TextfieldStyles
      ref={ref}
      id={props.name}
      as={props.multiline ? 'textarea' : 'input'}
      type={props.multiline ? undefined : props.type}
      {...props}
    >
      {props.children}
    </TextfieldStyles>
  );
});

Textfield.propTypes = {
  type: PropTypes.string,
  children: PropTypes.node,
  name: PropTypes.string.isRequired,
  multiline: PropTypes.bool,
  focused: PropTypes.bool,
  small: PropTypes.bool,
};

Textfield.defaultProps = {
  type: 'text',
  children: undefined,
  multiline: false,
  focused: undefined,
  small: undefined,
};

export default Textfield;
